"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolCallPart = toolCallPart;
exports.providerExecutedToolCall = providerExecutedToolCall;
const json_1 = require("../../utils/json");
function toolCallPart(fields) {
    if (typeof fields.toolName !== "string" || fields.toolName.length === 0) {
        return null;
    }
    return (0, json_1.compact)({
        type: "tool-call",
        toolCallId: (0, json_1.nullableString)(fields.toolCallId),
        toolName: fields.toolName,
        input: (0, json_1.toJsonValue)((0, json_1.parseIfString)(fields.input ?? {})),
        toolType: fields.toolType,
        providerExecuted: typeof fields.providerExecuted === "boolean"
            ? fields.providerExecuted
            : undefined,
    });
}
/**
 * Provider-executed named calls (OpenAI mcp_call, Anthropic server_tool_use /
 * mcp_tool_use): decorates an already-extracted call with providerExecuted
 * and provider-side extras (server_label, server_name, output, error) in
 * providerMetadata.
 */
function providerExecutedToolCall(part, extras) {
    if (!part)
        return null;
    return (0, json_1.compact)({
        ...part,
        providerExecuted: true,
        providerMetadata: extras ? (0, json_1.toProviderMetadata)(extras) : undefined,
    });
}
